/* ============================================================
   Campstead theme logic — live Shopify cart drawer, countdown,
   marquee, size-guide modal, product variant picker.
   ============================================================ */
(function () {
  const money = (cents) => "$" + (cents / 100).toFixed(2) + " CAD";

  /* ---------- toast ---------- */
  let toastTimer;
  window.csToast = function (msg) {
    const t = document.getElementById("toast");
    if (!t) return;
    t.textContent = msg; t.classList.add("show");
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove("show"), 2600);
  };

  /* ---------- cart drawer (real Shopify cart) ---------- */
  const drawer = document.getElementById("drawer"), veil = document.getElementById("veil");
  function openCart() { drawer.classList.add("open"); veil.classList.add("open"); }
  function closeCart() { drawer.classList.remove("open"); veil.classList.remove("open"); }
  window.csOpenCart = openCart;

  async function refreshCart() {
    const cart = await (await fetch("/cart.js")).json();
    const box = document.getElementById("drItems");
    document.getElementById("cartCount").textContent = cart.item_count;
    if (!cart.items.length) {
      box.innerHTML = '<p class="dr-empty">Cart empty. Coffee ranked first; shirts a close second.</p>';
    } else {
      box.innerHTML = cart.items.map((it, i) => `
        <div class="dr-item">
          <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, "_120x$1$2") : ""}" alt="">
          <div><div class="nm">${it.product_title.toUpperCase()}</div>
          <div>${it.variant_title && it.variant_title !== "Default Title" ? it.variant_title + " · " : ""}${it.quantity} × ${money(it.price)}</div></div>
          <button class="rm" data-line="${i + 1}">remove</button>
        </div>`).join("");
      box.querySelectorAll(".rm").forEach(b => b.addEventListener("click", async () => {
        await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line: +b.dataset.line, quantity: 0 }) });
        refreshCart();
      }));
    }
    document.getElementById("drTotal").textContent = money(cart.total_price);
    return cart;
  }
  window.csAddToCart = async function (variantId, qty) {
    const r = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 }) });
    if (r.ok) { await refreshCart(); openCart(); }
    else { const e = await r.json().catch(() => ({})); csToast(e.description || "Could not add — try again"); }
  };
  const co = document.getElementById("cartOpen");
  if (co) co.addEventListener("click", () => { refreshCart(); openCart(); });
  const cc = document.getElementById("cartClose");
  if (cc) cc.addEventListener("click", closeCart);
  if (veil) veil.addEventListener("click", closeCart);
  const ck = document.getElementById("checkoutBtn");
  if (ck) ck.addEventListener("click", () => { window.location.href = "/checkout"; });
  refreshCart();

  /* ---------- size-guide modal ---------- */
  const sgVeil = document.getElementById("sgVeil"), sgModal = document.getElementById("sgModal");
  function closeSG() { sgVeil.classList.remove("open"); sgModal.classList.remove("open"); }
  window.csOpenSG = function () { sgVeil.classList.add("open"); sgModal.classList.add("open"); };
  if (sgModal) {
    document.getElementById("sgClose").addEventListener("click", closeSG);
    sgVeil.addEventListener("click", closeSG);
    document.querySelectorAll(".sg-link").forEach(b => b.addEventListener("click", window.csOpenSG));
  }

  /* ---------- countdown ---------- */
  const cd = document.getElementById("countdown");
  if (cd) {
    const at = new Date(cd.dataset.dropAt || "2026-09-18T07:00:00");
    setInterval(() => {
      let d = Math.max(0, at - Date.now());
      const u = { d: Math.floor(d / 864e5), h: Math.floor(d / 36e5) % 24, m: Math.floor(d / 6e4) % 60, s: Math.floor(d / 1e3) % 60 };
      cd.querySelectorAll(".num").forEach(el => el.textContent = String(u[el.dataset.u]).padStart(2, "0"));
    }, 1000);
  }

  /* ---------- marquee (from live product titles) ---------- */
  const mq = document.getElementById("mqTrack");
  if (mq) {
    const names = [...document.querySelectorAll("[data-mq-name]")].map(e => e.dataset.mqName).slice(0, 12);
    if (names.length) {
      const half = names.map(n => `<span><i>✦</i>${n.toUpperCase()}</span>`).join("");
      mq.innerHTML = half + half;
    } else { mq.closest(".marquee").style.display = "none"; }
  }

  /* ---------- newsletter fallback message ---------- */
  const nl = document.getElementById("signupOk");
  if (nl && window.location.search.includes("customer_posted=true")) {
    nl.style.display = "block";
    const f = document.getElementById("signupForm"); if (f) f.style.display = "none";
  }

  /* ---------- product page ---------- */
  const pp = document.getElementById("productPage");
  if (pp) {
    const variants = JSON.parse(document.getElementById("ppVariants").textContent);
    const optCount = +pp.dataset.optCount;
    const sel = [];
    document.querySelectorAll(".opt-block").forEach((blk, oi) => {
      const first = blk.querySelector(".opt-btn.sel") || blk.querySelector(".opt-btn");
      sel[oi] = first ? first.dataset.v : null;
    });

    const mainImg = document.getElementById("ppMainImg");
    const priceEl = document.getElementById("ppPrice");
    const addBtn = document.getElementById("ppAdd");
    const qtyInput = document.getElementById("ppQty");

    function currentVariant() {
      return variants.find(v => {
        for (let i = 0; i < optCount; i++) if (v.options[i] !== sel[i]) return false;
        return true;
      });
    }
    function paint() {
      document.querySelectorAll(".opt-block").forEach((blk, oi) => {
        blk.querySelectorAll(".opt-btn").forEach(b => {
          b.classList.toggle("sel", b.dataset.v === sel[oi]);
          const probe = sel.slice(); probe[oi] = b.dataset.v;
          const m = variants.find(v => { for (let i = 0; i < optCount; i++) if (v.options[i] !== probe[i]) return false; return true; });
          b.classList.toggle("unavail", !m || !m.available);
        });
        const lbl = blk.querySelector(".opt-label b"); if (lbl) lbl.textContent = sel[oi];
      });
      const v = currentVariant();
      if (v) {
        priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ` <s>${money(v.compare_at_price)}</s>` : "");
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? "Add to cart" : "Sold out — check back";
        if (v.featured_image && mainImg) { mainImg.src = v.featured_image.src; }
      } else { addBtn.disabled = true; addBtn.textContent = "Unavailable"; }
    }
    document.querySelectorAll(".opt-block").forEach((blk, oi) => {
      blk.querySelectorAll(".opt-btn").forEach(b => b.addEventListener("click", () => { sel[oi] = b.dataset.v; paint(); }));
    });
    document.querySelectorAll(".pp-thumb").forEach(t => t.addEventListener("click", () => {
      mainImg.src = t.dataset.full;
      document.querySelectorAll(".pp-thumb").forEach(x => x.classList.remove("cur")); t.classList.add("cur");
    }));
    document.getElementById("qtyMinus").addEventListener("click", () => { qtyInput.value = Math.max(1, +qtyInput.value - 1); });
    document.getElementById("qtyPlus").addEventListener("click", () => { qtyInput.value = +qtyInput.value + 1; });
    addBtn.addEventListener("click", () => { const v = currentVariant(); if (v) csAddToCart(v.id, +qtyInput.value); });
    paint();
  }
})();
